import React from "react";
import PropTypes from "prop-types";
import { styled } from "@mui/system";
import { Button, CircularProgress } from "@mui/material";

// Styled MUI Button
const StyledButton = styled(Button)(({ theme }) => ({
  padding: theme.spacing(1, 3),
  textTransform: "none",
  fontWeight: 500,
  minWidth: 120,
}));

const ReusableButton = ({
  label,
  onClick,
  type = "button",
  size = "medium",
  variant = "contained",
  icon = null,
  sx = {},
  disabled = false,
  isSubmitting = false,
  submittingText = "Submitting...",
  loaderSize = 20,
  loaderColor = "inherit",
  ...ButtonProps
}) => {
  return (
    <StyledButton
      disabled={disabled || isSubmitting}
      type={type}
      size={size}
      variant={variant}
      startIcon={!isSubmitting ? icon : null}
      onClick={onClick}
      sx={{ ...sx }}
      {...ButtonProps}
    >
      {isSubmitting ? (
        <>
          {submittingText}
          <CircularProgress
            size={loaderSize}
            sx={{ color: loaderColor, ml: 1 }}
          />
        </>
      ) : (
        label
      )}
    </StyledButton>
  );
};

ReusableButton.propTypes = {
  label: PropTypes.string.isRequired,
  onClick: PropTypes.func,
  type: PropTypes.oneOf(["button", "submit", "reset"]),
  size: PropTypes.oneOf(["small", "medium", "large"]),
  variant: PropTypes.oneOf(["text", "outlined", "contained"]),
  icon: PropTypes.element,
  sx: PropTypes.object,
  disabled: PropTypes.bool,
  isSubmitting: PropTypes.bool,
  submittingText: PropTypes.string,
  loaderSize: PropTypes.number,
  loaderColor: PropTypes.string,
};

export default ReusableButton;
